/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type DeactivateBambooHRInput = {
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type DeactivateBambooHRMutationVariables = {
    input: DeactivateBambooHRInput;
};
export type DeactivateBambooHRMutationResponse = {
    readonly deactivateBambooHR: {
        readonly company: {
            readonly bambooHREnabled: boolean | null;
        } | null;
    } | null;
};
export type DeactivateBambooHRMutation = {
    readonly response: DeactivateBambooHRMutationResponse;
    readonly variables: DeactivateBambooHRMutationVariables;
};



/*
mutation DeactivateBambooHRMutation(
  $input: DeactivateBambooHRInput!
) {
  deactivateBambooHR(input: $input) {
    company {
      bambooHREnabled
      id
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "DeactivateBambooHRInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bambooHREnabled",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeactivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "deactivateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeactivateBambooHRMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "DeactivateBambooHRPayload",
        "kind": "LinkedField",
        "name": "deactivateBambooHR",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "DeactivateBambooHRMutation",
    "operationKind": "mutation",
    "text": "mutation DeactivateBambooHRMutation(\n  $input: DeactivateBambooHRInput!\n) {\n  deactivateBambooHR(input: $input) {\n    company {\n      bambooHREnabled\n      id\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '74d4c816bdea935a4057c6baea2c2d62';
export default node;
